import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {TabSwitcherConfig} from "./tab-switcher-configuration.interface";
import {RouterModule} from "@angular/router";
import {NgForOf, NgIf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
    selector: 'app-tab-switcher',
    templateUrl: './tab-switcher.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, NgForOf, NgIf, TranslatePipe],
    standalone: true
})
export class TabSwitcherComponent {
  @Input() public config: TabSwitcherConfig[] = [];

}
